  window.onpageshow = function(e) {
   if (e.persisted) {
      window.location.reload();
   }
};

document.addEventListener("DOMContentLoaded", function () {


  // 新日常折扣

const discount15=["TJMCKZ","43ZJ8P","S7A6MR","PQKJWC","H35V5N","MZTG0C","3X7SED","HMYS8J","8WT5R5","T6KDP5","ZJBJD2","P6D2CM","T8C4R8","C65KCF","GRRNHB","RKVXWM","0Z9D6A","TG84NF","AREA7K","ZE2CZE"];
const START_US_DATE='2026-09-24';

const bodyregular = document.querySelector('body.template-article');
if(!bodyregular)return;

const regularCode=bodyregular.querySelector('.regular-code'),
finalprice=document.querySelectorAll('.sticky-bar-form .regular-price-discount .final-price'),
claimbtn = bodyregular.querySelector('.dynamic-discount-banner-claim'),
price15=document.querySelectorAll('.sticky-bar-form .final-price-15');

if(!claimbtn)return;

function getUSDate(){
return new Intl.DateTimeFormat('en-CA',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
}

function getUSMidnightTimestamp(dateString){
const p=dateString.split('-'),year=+p[0],month=+p[1],day=+p[2];
let guess=Date.UTC(year,month-1,day);
for(let i=0;i<3;i++){
const f=new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',timeZoneName:'longOffset',hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'});
const parts=f.formatToParts(new Date(guess));
const offsetPart=parts.find(x=>x.type==='timeZoneName');
const offset=offsetPart?offsetPart.value.replace('GMT',''):'-08:00';
const match=offset.match(/^([+-])(\d{2}):?(\d{2})$/);
if(!match)break;
const sign=match[1]=='+'?1:-1;
guess=Date.UTC(year,month-1,day)-sign*(+match[2]*60+ +match[3])*60000;
}
return guess;
}

function getDaily15Data(){
const today=getUSDate();
const start=getUSMidnightTimestamp(START_US_DATE);
const current=getUSMidnightTimestamp(today);
let index=Math.floor((current-start)/(24*60*60*1000));
if(index<0)index=0;
return {date:today,code:discount15[index%discount15.length]};
}

function updatePrice(){
finalprice.forEach(el=>el.classList.add('hide'));
price15.forEach(el=>el.classList.remove('hide'));
}

function updateUI(){
const data=getDaily15Data();
if (claimbtn) claimbtn.classList.remove('hide');
if(regularCode)regularCode.textContent=data.code;
updatePrice();
}



function getNextMidnight(){
const today=getUSDate();
const next=new Date(getUSMidnightTimestamp(today)+36*60*60*1000);
const nextDate=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).format(next);
return getUSMidnightTimestamp(nextDate);
}

function updateCountdown(){
const remain=getNextMidnight()-Date.now();
if(remain<=0){updateUI();return;}
const total=Math.floor(remain/1000);
}

claimbtn.addEventListener('click',function(){
bodyregular.classList.add('regular-product');

});


  updateUI();
  updateCountdown();
setInterval(function(){
  updateUI();
  updateCountdown();
},1000);





});

$(".closeform").click(function(){
$(".sticky-bar-form").hide();
});

document.addEventListener('DOMContentLoaded', function () {
  var stickyBarForm = document.querySelector('.sticky-bar-form');

  if (!stickyBarForm) return;

  function toggleStickyBarFixed() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var triggerPoint = window.innerHeight * 0.2;

    if (scrollTop >= triggerPoint) {
      stickyBarForm.classList.add('fixed-sticky-cart');
    } else {
      stickyBarForm.classList.remove('fixed-sticky-cart');
    }
  }

  window.addEventListener('scroll', toggleStickyBarFixed);
  window.addEventListener('resize', toggleStickyBarFixed);

  toggleStickyBarFixed();
});